module.exports = __webpack_public_path__ + "img/header2.e5fab389.jpg";